import React, { createContext, useContext, useState, useCallback } from 'react';

export type SettingsTab = 'profile' | 'billing';

interface SettingsDialogContextType {
  open: boolean;
  initialTab: SettingsTab;
  openSettings: (tab?: SettingsTab) => void;
  closeSettings: () => void;
}

const SettingsDialogContext = createContext<SettingsDialogContextType | undefined>(undefined);

export const SettingsDialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [initialTab, setInitialTab] = useState<SettingsTab>('profile');

  const openSettings = useCallback((tab: SettingsTab = 'profile') => {
    setInitialTab(tab);
    setOpen(true);
  }, []);

  const closeSettings = useCallback(() => setOpen(false), []);

  const value: SettingsDialogContextType = { open, initialTab, openSettings, closeSettings };

  return <SettingsDialogContext.Provider value={value}>{children}</SettingsDialogContext.Provider>;
};

export const useSettingsDialog = (): SettingsDialogContextType => {
  const context = useContext(SettingsDialogContext);
  if (!context) {
    throw new Error('useSettingsDialog must be used within a SettingsDialogProvider');
  }
  return context;
};
